module.exports = __webpack_public_path__ + "static/media/VA.1288ef23.png";